export const AUTH_ACTION = {
	SIGN_IN:     'SIGN_IN',
	LOG_OUT:     'LOG_OUT',
	RENEW_TOKEN: 'RENEW_TOKEN',
}
